export const ENDPOINTS = {
  accounts: "accounts",
  backoffice: "backoffice",
  staff: "staff",
  system: "system",
  users: "users",
  stripe: "stripe",
} as const;
